import { type ReactNode } from 'react'

import { Typography } from '@gto/ui/typography'

type StackedFieldProps = { label: ReactNode; children: ReactNode }

/**
 * Label-over-value field for the narrow account-details columns, where the
 * 180px-label FieldRow grid would leave no room for values. The label is the
 * same uppercase eyebrow the KPI tiles use.
 */
export const StackedField = ({ label, children }: StackedFieldProps) => (
  <div className="flex min-w-0 flex-col gap-0.5">
    <Typography
      // tracking-[0.06em] matches the dashboard-kpi-tile eyebrow. No
      // letterSpacing token (the design tokens are all px-based).
      className="text-xs uppercase tracking-[0.06em]"
      color="text.secondary"
      variant="caption"
    >
      {label}
    </Typography>
    <div className="min-w-0">{children}</div>
  </div>
)
